export default __webpack_public_path__ + "static/media/product-11.50bb89b5.webp";